import { PageObjectType } from '@pages/setting/PageConfigurationDetail/pageConfigurationTypes';

export const objectFilter = (forObject?: PageObjectType, forId?: string) => {
  switch (forObject) {
    case PageObjectType.ACCOUNT:
      return { accountId: forId };
    case PageObjectType.GOAL:
      return { goalId: forId };
    case PageObjectType.HOUSEHOLD:
      return { clientGroupId: forId };
    case PageObjectType.SUB_ACCOUNT:
      return { subAccountId: forId };
    case PageObjectType.ACCOUNT_GROUP:
      return { accountGroupId: forId };
    default:
      return { userId: forId };
  }
};
